import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  GiftChoiceUnitCreate,
  GiftChoiceUnitData,
  GiftChoiceUnitUpdate,
} from './giftChoiceUnit.interface';

// 생성
export const createGiftChoiceUnit = async (
  data: GiftChoiceUnitCreate,
  role: LowerRole,
): Promise<GiftChoiceUnitData> => {
  const res = await api_.post(`/${role}/gift-choice-unit`, data);
  return res.data;
};

// 수정
export const updateGiftChoiceUnit = async (
  id: string,
  data: GiftChoiceUnitUpdate,
  role: LowerRole,
): Promise<GiftChoiceUnitData> => {
  const res = await api_.patch(`/${role}/gift-choice-unit/${id}`, data);
  return res.data;
};

// 삭제
export const deleteGiftChoiceUnit = async (
  id: string,
  role: LowerRole,
): Promise<void> => {
  await api_.delete(`/${role}/gift-choice-unit/${id}`);
};
